export const CONTACT_INFO = {
  FULL: 'FULL',
  BASIC: 'BASIC'
}